<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  fxHide.lt-sm
  [ngClass]="!isUserConsumer() ? 'nvc-black' : 'nvc-border-bottom'"
>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="nvc-header">
    <div fxLayout="row" fxFlex="25">
      <img
        (click)="goToHome()"
        *ngIf="whiteShopLogo"
        class="nvc-whiteshop-logo nvs-margin-side"
        [ngClass]="isUserConsumer() ? '' : 'ws-cursor-pointer'"
        [src]="whiteShopLogo"
        alt="whiteshopLogo"
      />
      <!-- <img (click)='goToHome()' class='nvc-whiteshop-logo' [src]="logoTypeWhite() ? whiteshopDarkLogo: whiteShopLogo" alt="whiteshopLogo"> -->
    </div>
    <div
      fxFlex="10"
      fxFlex.sm="15"
      class="nvs-header-text responsive-font-size"
      *ngIf="isCatalog && !isUserConsumer()"
    >
      <b
        id="e2e-stores-button"
        class="ws-cursor-pointer"
        (click)="goToMyStore()"
        [ngClass]="router.url.includes('stores') ? 'nvc-color-blue' : ''"
        >{{ getStoresText() }}</b
      >
    </div>
    <div
      [fxFlex]="isRetailer() ? '15' : '10'"
      fxFlex.sm="20"
      class="nvs-header-text responsive-font-size"
      *ngIf="!isSupplier && isAppointment"
    >
      <b
        id="e2e-bookings-button"
        (click)="goToMyAppointments()"
        class="ws-cursor-pointer"
        [ngClass]="router.url.includes('appointments') ? 'nvc-color-blue' : ''"
        >{{ getBookingText() }}</b
      >
    </div>
    <div
      id="myOrders"
      fxFlex="10"
      fxFlex.sm="13"
      class="nvs-header-text responsive-font-size"
    >
      <b
        (click)="goToMyOrders()"
        class="ws-cursor-pointer"
        [ngClass]="
          router.url.includes('myorders') &&
          !router.url.includes('consumer-cart')
            ? 'nvc-color-blue'
            : ''
        "
        >My Orders</b
      >
    </div>
    <div
      id="myOrders"
      fxFlex="10"
      fxFlex.sm="13"
      class="nvs-header-text responsive-font-size"
      *ngIf="showWishList && isUserConsumer()"
    >
      <b
        (click)="goToMyWishList()"
        class="ws-cursor-pointer"
        [ngClass]="router.url.includes('mywishlist') ? 'nvc-color-blue' : ''"
        >My Wishlist</b
      >
    </div>

    <!-- <div
    fxFlex="10"
    (click)="goToClickToCall()"
    class="nvs-header-text ws-cursor-pointer responsive-font-size"
  >
    <b
      id="e2e-stores-button"
      [ngClass]="router.url.includes('call') ? 'nvc-color-blue' : ''"
      >Click To Call</b
    >
  </div> -->

    <div fxFlex="5" *ngIf="showIcon()" class="notranslate">
      <mat-icon
        mat-icon-button
        [matMenuTriggerFor]="menu1"
        aria-label="language menu"
        svgIcon="translateBlack"
        class="language-icon ws-cursor-pointer"
        #language="matMenuTrigger"
        (click)="onClickLanguage()"
      >
      </mat-icon>

      <mat-menu #menu1="matMenu" overlapTrigger="true">
        <button
          mat-menu-item
          *ngFor="let lang of languageList"
          (click)="changeLang(lang.code)"
        >
          <span class="notranslate">{{ lang.label }}</span>
        </button>
      </mat-menu>
    </div>
    <div
      class="nvc-black"
      *ngIf="loggedIn()"
      fxLayout
      fxLayoutAlign="end center"
      fxLayoutGap="1em"
      class="responsive-font-size-1 nvs-margin-side-2 nvc-font-weight-normal nvc-crop"
    >
      <div
        *ngIf="!isUserConsumer()"
        class="ws-cursor-pointer ws-notification-icon"
        (click)="openNotifications()"
      >
        <img
          src="assets/icons/notification.svg"
          class="ws-notification-image"
        />
        <div
          *ngIf="storesService.notificationCount"
          class="sc-icon-image-dot"
        ></div>
      </div>
      <div class="sc-display-name notranslate">
        {{
          user.displayName
            ? user.displayName.length > 40
              ? user.displayName.slice(0, 40) + "..."
              : user.displayName
            : user.username.length > 40
            ? user.username.slice(0, 40) + "..."
            : user.username
        }}
      </div>
      <div
        id="usericon"
        class="ws-cursor-pointer"
        (click)="onClickProfile($event)"
      >
        <img
          class="nvs-img-user"
          [matMenuTriggerFor]="profileMenu"
          (mouseenter)="onHover($event, true)"
          #trigger="matMenuTrigger"
          src="{{
            user && user.profileImageURL
              ? imagesService.getImageURL(user.profileImageURL)
              : defaultImage
          }}"
          alt="userImage"
        />
        <!-- <mat-icon class="fa fa-caret-down nvc-position-relative nvc-white">
                </mat-icon> -->
      </div>
      <div *ngIf="isUserConsumer() && !isRetailer() && isCheckoutEnabled">
        <div
          class="sc-profile-icon-div sc-border-primary ws-cursor-pointer nvc-position-relative"
          fxLayoutAlign="center center"
          (click)="goToCart()"
        >
          <mat-icon svgIcon="consumerCart" class="cart-icon"> </mat-icon>
          <div class="ws-cart-count">
            {{ slotService.cartCount || "0" }}
          </div>
        </div>
      </div>
      <mat-menu #profileMenu="matMenu" overlapTrigger="true">
        <span (mouseleave)="onHover($event)">
          <div
            mat-menu-item
            class="nvc-image-div"
            (click)="$event.stopPropagation()"
          >
            <img
              id="usericons"
              class="nvs-img-user-menu image-z-index"
              src="{{
                user && user.profileImageURL
                  ? imagesService.getImageURL(user.profileImageURL)
                  : defaultImage
              }}"
              alt="userImage"
            />
          </div>
          <button mat-menu-item (click)="goToMyProfile()">My Profile</button>
          <button
            *ngIf="user && user.type !== 'B2C'"
            mat-menu-item
            (click)="goToMyCompany()"
          >
            My Company
          </button>
          <button
            mat-menu-item
            *ngIf="!isRetailer() && loggedIn() && isCheckoutEnabled"
            (click)="goToMyAddresses()"
          >
            My Addresses
          </button>
          <button
            *ngIf="getBusinessUnit()"
            mat-menu-item
            (click)="goToMyBusinessUnits()"
          >
            My Business Units
          </button>
          <button
            *ngIf="user && user.type !== 'B2C'"
            mat-menu-item
            (click)="goToTemplates()"
          >
            Marketing Tools
          </button>
          <button mat-menu-item (click)="changePassword()">
            Change Password
          </button>
          <button
            mat-menu-item
            (click)="openGuides()"
            *ngIf="user && user.type !== 'B2C'"
          >
            Guides
          </button>
          <button
            mat-menu-item
            (click)="goToPrivacyPolicy()"
            *ngIf="!isRetailer() && loggedIn()"
          >
            Privacy Policy
          </button>
          <button id="logout" mat-menu-item (click)="logOut()">Log Out</button>
        </span>
      </mat-menu>
      <!-- <div
        class="ws-cursor-pointer nvc-border-radius ws-primary-border"
        (click)="goToDetailedOrders()"
        *ngIf="isCustomerLogged()"
      >
        <div class="nvc-text-align-center nvc-cart-count">
          <h5 class="nvc-color-white nvc-background-blue nvc-border-radius">
            {{
              this.slotService.cart && this.slotService.cart.length
                ? this.slotService.cart.length
                : 0
            }}
          </h5>
        </div>
        <img class="nvc-cart" src="{{ blueCart }}" alt="user cart" />
      </div> -->
    </div>
    <div
      fxLayout
      fxFlex="10"
      *ngIf="!loggedIn()"
      class="nvs-margin-side ws-cursor-pointer"
    >
      <div
        fxFlex="30"
        id="userimage"
        (click)="profileImageClicked()"
        class="fa fa-user nvs-size"
      ></div>
      <!-- <div fxFlex='30' class='fa fa-search nvc-black nvs-size'></div> -->
    </div>
    <!-- <div fxLayout fxFlex='10' *ngIf='!loggedIn()'>
            <a href="https://youtu.be/92hIWbnpeuU" target="_blank" class="nvc-width-hundred">
                <button class="nvs-button">
                    VIEW DEMO
                </button>
            </a>
        </div> -->
  </div>
  <!-- <mat-divider></mat-divider> -->
</div>
